import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteMedicine() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((medicineId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/medicines/${medicineId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
